import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useLocation, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// @mui icons
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bgg.jpg";
import login, { authenticateGoogleUser, resetPassword } from "../api/authenticationApi";

// login
import GoogleLogin from "react-google-login";
import { gapi } from 'gapi-script';
import styled from "styled-components";
import { CircularProgress } from "@mui/material";
import MDSnackbar from "components/MDSnackbar";
import {
  clearCheckoutIntent,
  getCheckoutPlanFromSearch,
  getPlanIntentContent,
  resolvePostAuthPath,
} from "utils/checkoutFlow";
import { ClaimLatestPayment } from "components/Payment/PaymentApi";
import { RESET_PASSWORD_ROUTE, SIGN_UP_ROUTE } from "utils/routes";
import { isNativeApp } from "utils/platform";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [name, setName] = useState('');
  const [userName, setUserName] = useState('');
  const [pass, setPass] = useState('');
  const [isLoading, setIsLoagding] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(null);
  const [errors, setErrors] = useState({ userName: '', pass: '' });


  const clientId = "429303876753-fijpsiil2qt0amasetqsj1320a38rmj6.apps.googleusercontent.com";

  useEffect(() => {
    gapi.load("client:auth2", () => {
      gapi.auth2.init({ clientId: clientId })
    })
  }, []);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shouldClaimPaymentAfterAuth = searchParams.get("afterPayment") === "1";
  const shouldUpgradeNowAfterAuth = searchParams.get("upgradeNow") === "1";
  const selectedPlanIntent = getPlanIntentContent(getCheckoutPlanFromSearch(location.search));
  const shouldShowPlanContext = !shouldClaimPaymentAfterAuth && selectedPlanIntent?.checkoutEnabled;
  const planContextTitle = shouldUpgradeNowAfterAuth
    ? `Entre para continuar com o plano ${selectedPlanIntent?.name}`
    : selectedPlanIntent?.authTitle;
  const planContextDescription = shouldUpgradeNowAfterAuth
    ? "Assim que você autenticar, vamos te levar direto para o checkout para concluir a liberação do recurso premium."
    : selectedPlanIntent?.authDescription;

  useEffect(() => {
    const checkoutEmail = new URLSearchParams(location.search).get("email");
    if (checkoutEmail) {
      setUserName(checkoutEmail);
    }
  }, [location.search]);

  const handlePostAuthFlow = async (isNewUser) => {
    if (shouldClaimPaymentAfterAuth) {
      try {
        await ClaimLatestPayment();
      } catch (error) {
        console.log(error);
      } finally {
        clearCheckoutIntent();
      }
    }

    navigate(resolvePostAuthPath({ search: location.search, forceAppHome: isNativeApp() }));
  };

  const handleSubmitLogin = async () => {
    if (!validateForm()) return;

    setIsLoagding(true);
    await login(userName, pass)
      .then(async e => {

        if (!e?.errorCode) {
          setIsLoagding(false);
          localStorage.setItem("tradez-token", `${e.token.accessToken}`);
          await handlePostAuthFlow(e.isNewUser);
        } else {
          setOpenSnackBar({ message: e?.message })
        }
        return e;
      })
      .catch(e => {
        console.log(e)
      })
      .finally(() => setIsLoagding(false))
  }

  const handleResetPassword = async () => {

    await resetPassword(userName)
      .then(async e => {

        if (!e?.errorCode) {
          setIsLoagding(false);
        } else {
          setOpenSnackBar({ message: e?.message })
        }
        return e;
      })
      .catch(e => {
        console.log(e)
      })
      .finally(() => setIsLoagding(false))
  }

  const responseGoogle = (response) => {
    const { profileObj: { email, name, imageUrl } } = response;

    authenticateUser(email, name, imageUrl);
  }

  const authenticateUser = async (userName, name, image) => {
    setIsLoagding(true);
    await authenticateGoogleUser(userName, name, image)
      .then(e => {

        if (e.status == 200) {
          return e.json();
        }
      })
      .then(e => {
        localStorage.setItem("tradez-token", `${e.token.accessToken}`);
        return handlePostAuthFlow(e.isNewUser);
      })
      .catch(e => console.log(e))
      .finally(() => setIsLoagding(false))
  }

  const validateForm = () => {
    let valid = true;
    const newErrors = { userName: '', pass: '' };

    if (!userName) {
      newErrors.userName = "E-mail é obrigatório";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(userName)) {
      newErrors.userName = "Formato de e-mail inválido";
      valid = false;
    }

    if (!pass) {
      newErrors.pass = "Senha é obrigatória";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };


  return (
    <>
      <BasicLayout image={bgImage}>
        <Card>
          <StyledContent
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={2}
            mb={1}
            textAlign="center"
          >
            <MDBox mt={-2} mb={-6}>
              <img width={250} src="/p3602.png" />
            </MDBox>

            <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>

            </Grid>
          </StyledContent>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form">
              {shouldShowPlanContext && (
                <PlanIntentCard>
                  <PlanIntentEyebrow>Plano selecionado: {selectedPlanIntent.name}</PlanIntentEyebrow>
                  <PlanIntentTitle>{planContextTitle}</PlanIntentTitle>
                  <PlanIntentText>{planContextDescription}</PlanIntentText>
                </PlanIntentCard>
              )}
              <MDBox mb={2}>
                <MDInput
                  error={!!errors.userName}
                  value={userName}
                  onChange={e => setUserName(e.target.value)}
                  type="email"
                  label="E-mail"
                  fullWidth />
                {!!errors.userName && <StyledSpan>{errors.userName}</StyledSpan>}
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  error={!!errors.pass}
                  onChange={e => setPass(e.target.value)}
                  type="password"
                  label="Senha"
                  fullWidth />
                <StyledResetPassDiv>

                  <MDTypography
                    variant="button"
                    color="text"
                    onClick={() => navigate(RESET_PASSWORD_ROUTE)}
                  // onClick={handleResetPassword}
                  >

                    Esqueceu a senha?

                  </MDTypography>
                </StyledResetPassDiv>
                {!!errors.pass && <StyledSpan>{errors.pass}</StyledSpan>}
              </MDBox>
              <MDBox mt={4} mb={1}>
                <MDButton disabled={isLoading} onClick={handleSubmitLogin} variant="gradient" color="info" fullWidth>
                  {isLoading
                    ? <CircularProgress color="inherit" size={16} />
                    :
                    'Entrar'
                  }
                </MDButton>
                <MDBox mt={2} mb={1} />

                <GoogleLogin
                  clientId={clientId}
                  onSuccess={responseGoogle}
                  render={renderProps => (
                    <MDButton disabled={isLoading} onClick={renderProps.onClick} variant="gradient" color="error" fullWidth>
                      {isLoading
                        ? <CircularProgress color="inherit" size={16} />
                        :
                        <GoogleIcon color="inherit" />
                      }
                    </MDButton>
                  )}
                // onFailure={responseGoogle}
                // icon={false}
                // cookiePolicy={'single_host_origin'} //testar isso aqui
                />

              </MDBox>
              <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Ainda não se cadastrou?{" "}
                <MDTypography
                    component={Link}
                    to={`${SIGN_UP_ROUTE}${location.search}`}
                    variant="button"
                    color="info"
                    fontWeight="medium"
                    textGradient
                  >
                    Crie sua conta aqui
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>

      </BasicLayout>

      <MDSnackbar
        icon="check"
        open={openSnackBar}
        color="error"
        title={openSnackBar?.message}
        onClose={() => setOpenSnackBar(false)}
        close={() => setOpenSnackBar(false)}
      />
    </>
  );
}

const StyledContent = styled(MDBox)`
  background: radial-gradient(circle at 135% 651%, #f28371 79%, #f28371 1%, transparent 0%) ,#f0ba8d !important; 
`;

const StyledSpan = styled.span`
  color: red;
  font-size:10px;
  display:flex;
`;

const StyledResetPassDiv = styled.div`
  justify-content: flex-end;
  display: flex;
  padding: 5px 5px 0 0;

  span {
    font-size: 0.8rem !important;
    cursor: pointer;
  }
`;

const PlanIntentCard = styled.div`
  display: grid;
  gap: 0.45rem;
  margin-bottom: 1.25rem;
  padding: 0.95rem 1rem;
  border-radius: 16px;
  border: 1px solid rgba(15, 118, 110, 0.18);
  background: linear-gradient(180deg, rgba(240, 253, 250, 0.96), rgba(255, 255, 255, 0.98));
`;

const PlanIntentEyebrow = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0f766e;
`;

const PlanIntentTitle = styled.span`
  font-size: 0.98rem;
  font-weight: 700;
  color: #0f172a;
`;

const PlanIntentText = styled.span`
  font-size: 0.84rem;
  line-height: 1.55;
  color: #475569;
`;

export default Basic;
